import type { ReactNode } from "react";
import { cn } from "./cn";

export function EmptyState({
  icon,
  title,
  body,
  hint,
  action,
  size = "md",
  className,
}: {
  icon?: ReactNode;
  title: string;
  body?: string;
  hint?: string;
  action?: ReactNode;
  size?: "sm" | "md";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center text-center",
        size === "md" ? "px-6 py-14" : "px-4 py-8",
        className,
      )}
    >
      {icon ? (
        <span
          aria-hidden
          className={cn(
            "mb-5 grid place-items-center rounded-full bg-brand-softer text-brand ring-1 ring-brand/10",
            size === "md" ? "size-16" : "size-11",
          )}
        >
          {icon}
        </span>
      ) : null}
      <h3
        className={cn(
          "font-display font-bold text-ink",
          size === "md" ? "text-lg" : "text-base",
        )}
      >
        {title}
      </h3>
      {body ? (
        <p className="mt-2 max-w-md text-base text-ink-3">{body}</p>
      ) : null}
      {hint ? <p className="mt-1.5 max-w-md text-xs text-ink-4">{hint}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
